import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import reqres from '../../assets/img/reqres.png'
import reqres2 from '../../assets/img/reqres2.png'
import reqres3 from '../../assets/img/reqres3.png'


const JavaScriptReqres= () => {
  const [language, changeLanguage] = useState("javascript");
  const [lineNumbers, toggleLineNumbers] = useState(false);

  const code1 = (
  'text',
  `
  fetch("https://reqres.in/api/users?page=2", {
          method: 'GET',
        })
          .then(response => response.json())
          .then(responseJson => {
             console.warn(responseJson);
          })
          .catch(error => {
            {
              alert(error)
            }
        }),
  `
  );

  const code2 = (
  'text',
  `
  {
    "page": 2,
    "per_page": 6,
    "total": 12,
    "total_pages": 2,
    "data": [
        {
            "id": 7,
            "email": "michael.lawson@reqres.in",
            "first_name": "Michael",
            "last_name": "Lawson",
            "avatar": "https://reqres.in/img/faces/7-image.jpg"
        },
        {
            "id": 8,
            "email": "lindsay.ferguson@reqres.in",
            "first_name": "Lindsay",
            "last_name": "Ferguson",
            "avatar": "https://reqres.in/img/faces/8-image.jpg"
        },
        {
            "id": 9,
            "email": "tobias.funke@reqres.in",
            "first_name": "Tobias",
            "last_name": "Funke",
            "avatar": "https://reqres.in/img/faces/9-image.jpg"
        },
        {
            "id": 10,
            "email": "byron.fields@reqres.in",
            "first_name": "Byron",
            "last_name": "Fields",
            "avatar": "https://reqres.in/img/faces/10-image.jpg"
        },
        {
            "id": 11,
            "email": "george.edwards@reqres.in",
            "first_name": "George",
            "last_name": "Edwards",
            "avatar": "https://reqres.in/img/faces/11-image.jpg"
        },
        {
            "id": 12,
            "email": "rachel.howell@reqres.in",
            "first_name": "Rachel",
            "last_name": "Howell",
            "avatar": "https://reqres.in/img/faces/12-image.jpg"
        }
    ],
    "support": {
        "url": "https://reqres.in/#support-heading",
        "text": "To keep ReqRes free, contributions towards server costs are appreciated!"
    }
  }
  `
  );

  const code4 = (
  'text',
  `
  const postData = {
  username: 'john_doe',
  password: 'secret123'
};

// Make a POST request
axios.post('https://api.example.com/login', postData)
  .then(response => {
    console.log(response.data); // Process the response data
  })
  .catch(error => {
    console.error('Axios error:', error);
  });
  `
  );

  const code5 = (
  'text',
  ` fetch("https://reqres.in/api/users?page=2", {
          method: 'GET',
        })
          .then(response => response.json())
          .then(responseJson => {
             console.warn(responseJson);
             var html = "";
             responseJson.data.map((item, index) => {
               html+="<div class='row'>";
               html+="<div class='card-group'>";
               html+="<div class='card'>";
               html+="<img src="+item.avatar+" class='card-img-top'>";
               html+="<div class='card-body'>";
               html+="<h5 class='card-title'>"+item.first_name+" "+item.last_name+"</h5>";
               html+="<p class='card-text'>"+item.email+"</p>";
               html+="<p class='card-text'>"+responseJson.support.text+"</p>";
               html+=\`<button data-bs-toggle="modal" data-bs-target="#exampleModal" onclick='readMore(\${item.id})' class='btn btn-primary'>Read More</button>\`;
               html+="</div>";
               html+="</div>";
               html+="</div>";
               html+="</div>";
             })
             document.getElementById("card").innerHTML = html;
          })
          .catch(error => {
            {
              alert(error)
            }
    });
  `
  );
  const code6 = (
  'text',
  ` <!DOCTYPE html>
    <html lang="en" dir="ltr">
  <head>
    <meta charset="utf-8">
    <title>Fetch API</title>
     <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossorigin="anonymous">
     <script src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.11.8/dist/umd/popper.min.js" integrity="sha384-I7E8VVD/ismYTF4hNIPjVp/Zjvgyol6VFvRkX/vR+Vc4jQkC+hVqc2pM8ODewa9r" crossorigin="anonymous"></script>
     <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.min.js" integrity="sha384-0pUGZvbkm6XF6gxjEnlmuGrJXVbNuzT9qBBavbLwCsOGabYfZo0T0to5eqruptLy" crossorigin="anonymous"></script>
  </head>
  <body>
  <div class="row">
  <div class="d-flex" id="card">
  </div>
  </div>
  </body>
  </html>
  `
  );
  const code7 = (
  'text',
  `html+=\`<button data-bs-toggle="modal" data-bs-target="#exampleModal" onclick='readMore(\${item.id})' class='btn btn-primary'>Read More</button>\`;
  `
  );
  const code8 = (
  'text',
  `readMore = (id) => {
   fetch(\`https://reqres.in/api/users?id=\${id}\`, {
           method: 'GET',
         })
           .then(response => response.json())
           .then(responseJson => {
              // console.warn(responseJson.data);
              var html = "";
                html+="<div class='row'>";
                html+="<div class='card-group'>";
                html+="<div class='card'>";
                html+="<img src="+responseJson.data.avatar+" class='card-img-top'>";
                html+="<div class='card-body'>";
                html+="<h5 class='card-title'>"+responseJson.data.first_name+" "+responseJson.data.last_name+"</h5>";
                html+="<p class='card-text'>"+responseJson.data.email+"</p>";
                html+="<p class='card-text'>"+responseJson.support.text+"</p>";
                html+="</div>";
                html+="</div>";
                html+="</div>";
                html+="</div>";

              document.getElementById("card-user").innerHTML = html;
           })
           .catch(error => {
             {
               alert(error)
             }
     })
    }
  `
  );
  const code9 = (
  'text',
  `<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel"></h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div id="card-user">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>
  `
  );
  const code10 = (
  'text',
  `<!DOCTYPE html>
<html lang="en" dir="ltr">
  <head>
    <meta charset="utf-8">
    <title>Fetch API</title>
     <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossorigin="anonymous">
     <script src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.11.8/dist/umd/popper.min.js" integrity="sha384-I7E8VVD/ismYTF4hNIPjVp/Zjvgyol6VFvRkX/vR+Vc4jQkC+hVqc2pM8ODewa9r" crossorigin="anonymous"></script>
     <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.min.js" integrity="sha384-0pUGZvbkm6XF6gxjEnlmuGrJXVbNuzT9qBBavbLwCsOGabYfZo0T0to5eqruptLy" crossorigin="anonymous"></script>
  </head>
  <body>
  <div class="row">
  <div class="d-flex" id="card">
  </div>
  </div>

<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel"></h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div id="card-user">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>

<script>
  fetch("https://reqres.in/api/users?page=2", {
          method: 'GET',
        })
          .then(response => response.json())
          .then(responseJson => {
             //console.warn(responseJson);
             var html = "";
             responseJson.data.map((item, index) => {
               html+="<div class='row'>";
               html+="<div class='card-group'>";
               html+="<div class='card'>";
               html+="<img src="+item.avatar+" class='card-img-top'>";
               html+="<div class='card-body'>";
               html+="<h5 class='card-title'>"+item.first_name+" "+item.last_name+"</h5>";
               html+="<p class='card-text'>"+item.email+"</p>";
               html+="<p class='card-text'>"+responseJson.support.text+"</p>";
               html+=\`<button data-bs-toggle="modal" data-bs-target="#exampleModal" onclick='readMore(\${item.id})' class='btn btn-primary'>Read More</button>\`
               html+="</div>";
               html+="</div>";
               html+="</div>";
               html+="</div>";
             })
             document.getElementById("card").innerHTML = html;
          })
          .catch(error => {
            {
              alert(error)
            }
    })

 readMore = (id) => {
   fetch(\`https://reqres.in/api/users?id=\${id}\`, {
           method: 'GET',
         })
           .then(response => response.json())
           .then(responseJson => {
              // console.warn(responseJson.data);
              var html = "";
                html+="<div class='row'>";
                html+="<div class='card-group'>";
                html+="<div class='card'>";
                html+="<img src="+responseJson.data.avatar+" class='card-img-top'>";
                html+="<div class='card-body'>";
                html+="<h5 class='card-title'>"+responseJson.data.first_name+" "+responseJson.data.last_name+"</h5>";
                html+="<p class='card-text'>"+responseJson.data.email+"</p>";
                html+="<p class='card-text'>"+responseJson.support.text+"</p>";
                html+="</div>";
                html+="</div>";
                html+="</div>";
                html+="</div>";

              document.getElementById("card-user").innerHTML = html;
           })
           .catch(error => {
             {
               alert(error)
             }
     })
 }
</script>
  </body>
  </html>
  `
  );

  return(
    <HTMLCourseNavProvider>
    <div className="container-fluid">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-10">

    <h3><strong>Reqres</strong></h3>
      <p>Reqres is a powerful tool for API testing and mocking that provides developers with the ability to simulate server responses and interact with APIs in a controlled environment. It offers a range of features designed to streamline the API testing process and improve the efficiency of development workflows.</p>

      <div class="alert alert-secondary" role="alert">
      <h3><strong>Features of Reqres:</strong></h3>
      <ol>
      <li><strong>Mocking Endpoints:</strong> Reqres allows developers to easily create mock servers to simulate API endpoints. This enables developers to test their applications without relying on external APIs or backend services, reducing dependencies and speeding up development cycles.</li>
      <li><strong>Custom Responses:</strong> With Reqres, developers can define custom responses for each endpoint, including status codes, headers, and response bodies. This flexibility allows developers to simulate a variety of scenarios and test edge cases effectively.</li>
      <li><strong>Dynamic Responses:</strong> Reqres supports dynamic responses, allowing developers to generate response data dynamically based on request parameters or conditions. This feature is particularly useful for testing complex scenarios and handling dynamic data.</li>
      <li><strong>Request Matching:</strong> Reqres provides powerful request matching capabilities, allowing developers to define criteria for matching incoming requests to specific endpoints. This enables developers to create precise mock server configurations and simulate various request scenarios.</li>
      <li><strong>Stateful Mocking:</strong> Reqres supports stateful mocking, allowing developers to maintain state across multiple requests within the same session. This feature is essential for testing workflows that involve multiple API calls or interactions with session-based services.</li>
      <li><strong>Integration with Testing Frameworks:</strong> Reqres seamlessly integrates with popular testing frameworks such as Jest, Mocha, and PHPUnit, making it easy to incorporate API testing into existing testing workflows. This integration simplifies the process of writing and executing API tests alongside other tests in your test suite.</li>
      <li><strong>User-Friendly Interface:</strong> Reqres provides a user-friendly web interface for managing mock server configurations, defining endpoints, and monitoring request activity. This intuitive interface makes it easy for developers to create and manage mock servers without requiring extensive technical knowledge.</li>
      <li><strong>Open Source and Extensible:</strong> Reqres is an open-source tool with a thriving community of developers contributing to its development and improvement. It offers extensive documentation and support, as well as opportunities for customization and extension to suit specific project requirements.</li>
      </ol>
     </div>

      <div class="alert alert-secondary" role="alert">
      <h3><strong>Getting Started</strong></h3>
      <p>We have covered creating a mock Reqres server in our Node JS course.</p>
      <p>To quickly fetch and post mock data in our JavaScript application, go to <a className="text-primary" href="https://reqres.in">reqres.in</a></p>
      <img className="img-responsive mb-4" style={{ width: '100%', height: 'auto' }} src={reqres} alt="REQRES" />
      </div>

        <div id="fetch" className="alert alert-secondary mt-3" role="alert">
        <h3><strong>Fetch Data:</strong></h3>
         <p>Here we are going to fetch a list of users from an endpoint. We want want to be able to display the names, images, emails and contributions of users in a Bootstrap card. We will be using two endpoints from reqres:
         <ol className="mt-3">
         <li>https://reqres.in/api/users?page=2 — to list all users</li>
         <li>https://reqres.in/api/users?id=id — to view a single user</li>
         </ol>
         </p>
          <CopyBlock
          language={language}
          text={code1}
          showLineNumbers={lineNumbers}
          theme={dracula}
          wrapLines={true}
          codeBlock
          />
          <br />
          <h4><strong>Here's the response for the first endpoint:</strong></h4>
          <CopyBlock
          language={language}
          text={code2}
          showLineNumbers={lineNumbers}
          theme={dracula}
          wrapLines={true}
          codeBlock
          />
          <br />
         <p>Next, we want to to loop through the data and dispalay each user in a card.</p>
         <p>We will modify our JavaScript code as follows:</p>
         <CopyBlock
         language={language}
         text={code5}
         showLineNumbers={lineNumbers}
         theme={dracula}
         wrapLines={true}
         codeBlock
         />
         <br />
         <p>Next, we add our HTML code as follows: </p>
         <CopyBlock
         language={'html'}
         text={code6}
         showLineNumbers={lineNumbers}
         theme={dracula}
         wrapLines={true}
         codeBlock
         />
         <br />
         <h4><strong>Here's what you should have so far:</strong></h4>
         <img className="img-responsive mb-4" style={{ width: '100%', height: 'auto' }} src={reqres2} alt="REQRES" />
         <p>Next, we need to add our modal class. But before we do that we need to create a function and pass the user id and we will be making use of the second endpoint. We will modify our button as follows:</p>
         <CopyBlock
         language={'html'}
         text={code7}
         showLineNumbers={lineNumbers}
         theme={dracula}
         wrapLines={true}
         codeBlock
         />
         <br />
         <p>We will create our readMore() function:</p>
         <CopyBlock
         language={language}
         text={code8}
         showLineNumbers={lineNumbers}
         theme={dracula}
         wrapLines={true}
         codeBlock
         />
         <br />
         <p>Next, we'll add our modal as follows:</p>
         <CopyBlock
         language={language}
         text={code9}
         showLineNumbers={lineNumbers}
         theme={dracula}
         wrapLines={true}
         codeBlock
         />
         <br />
         <h4><strong>Here's the full code</strong></h4>
         <CopyBlock
         language={'html'}
         text={code10}
         showLineNumbers={lineNumbers}
         theme={dracula}
         wrapLines={true}
         codeBlock
         />
         <br />
         <h4><strong>Here's the result:</strong></h4>
         <img className="img-responsive mb-4" style={{ width: '100%', height: 'auto' }} src={reqres3} alt="REQRES" />
        </div>



             </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptReqres
